/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import Toast from './Toast.js';
export const ToastWrapper = React.forwardRef((_, ref) => {
    const [toasts, setToasts] = React.useState([]);
    const [placement, setPlacement] = React.useState('top');
    const placementPosition = placement.startsWith('top') ? 'top' : 'bottom';
    React.useImperativeHandle(ref, () => ({
        setToasts,
        setPlacement,
    }), []);
    return (React.createElement("span", { className: cx(`iui-toast-wrapper`, `iui-placement-${placement}`) }, toasts.map((toastProps) => {
        return (React.createElement(Toast, { key: toastProps.id, placementPosition: placementPosition, ...toastProps }));
    })));
});
